import Controller from '@ember/controller';
import { service } from '@ember/service';
import type SessionService from 'garaje/services/session';

export default class NotFoundController extends Controller {
  @service declare session: SessionService;

  get isLoggedIn(): boolean {
    return this.session.isAuthenticated;
  }

  logOutUser = (): void => {
    void this.session.invalidate();
  };
}
